<style scoped>
  .event-item{
    display: flex;
    padding: 15px;
    background: #fff;
    border-bottom: 1px solid #eee;
    align-items: center;
    justify-content: space-between;
  }
  .event-image {
    width: 100px;
    height: 100px;
    background: #eee;
    margin-right: 10px;
  }
  .event-info {
    margin-right: 10px;
    width: 100%;
    overflow: hidden;
  }
  .event-info > p {
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .event-date {
    min-width: 50px;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
  .avatar{
    min-width: 45px;
    margin-right: 10px;
  }
  p.month{
    color: #f00;
    font-size: 1em;
  }
  p.date{
    font-size: 1.6em;
  }
</style>

<template>
  <AppLayout class="events-component">
    <Row type="flex" justify="center">
      <Col :span="24">
        <div class="event-container" v-if="events">
          <div class="event-item" v-for="(event, indx) in events.data" :key="indx" v-on:click="reRoute(event.id)">
            <div class="avatar">
              <Avatar size="large" shape="square" :src="event.thumbnail_photo[0].small"/>
            </div>
            <div class="event-info">
              <h3>{{event.title}}</h3>
              <!-- <p>{{event.description}}</p> -->
            </div>
            <div class="event-date" v-if="event.pages[0]">
              <p class="month">{{parseDateMonth(event.pages[0].data.event_start_date)}}</p>
              <p class="date">{{parseDateDate(event.pages[0].data.event_start_date)}}</p>
            </div>
          </div>
        </div>
        <!-- <EventSingleComponent></EventSingleComponent> -->
      </Col>
    </Row>
  </AppLayout>
</template>

<script>
  import moment from 'moment'
  import EventSingleComponent from '@/components/EventSingleComponent'

  export default {
    name: 'EventsComponent',
    components: {
      EventSingleComponent
    },
    computed: {
      events: {
        get() {
          return this.$store.state.events.events;
        }
      }
    },
    methods: {
      parseDateMonth(date) {
        return moment(date).format("MMM").toUpperCase()
      },
      parseDateDate(date) {
        return moment(date).format("D")
      },
      reRoute(id){
        this.$router.push({ path: '/resources/' + id })
      }
    }
  }
</script>
